// extracted by mini-css-extract-plugin
export default {"link":"header-nav-link_link__hQpos","linkActive":"header-nav-link_linkActive__97VVB","logo":"header-nav-link_logo__C-BnP"};